module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Intro#uf8Qjoo6P9KToCKBqDLZEpA"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#u4AYvIbL6eeAFhqZ4HoswWC"
    }
  }, [_vm._v("CHAPTER ONE: TURNABOUT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_02#uMWgUg2Zsqzx68BUVLSZVk2"
    }
  }, [_vm._v("CHAPTER TWO: BOBBY DEPARTS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_03#upIOqg9Bgp3TjBtPDYvTBnD"
    }
  }, [_vm._v("CHAPTER THREE: ALIBI")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_04#uKukmZ2P33VPQlEmjKvRCBC"
    }
  }, [_vm._v("CHAPTER FOUR: ZELLNER FACTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#utwBfNpUM8fFT8nSGcGtys4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE: SKINNY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#ulkszyDbSUuTKqxJqZx7Hs2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX: AVERY’S PHONE CALL")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#ukbNjuEiprnI9EOJ6NnfpaG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: COMPUTER BLUES")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#uLZK8ZVJIzjBUtuAkUWeUn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: BOBBY’S OBSESSIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_09#uVHyKI8laJNFY2KOtZWCqbF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE: SHADY DEPARTMENT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_10#uOPugOPcARI8MdsTR6Zqh49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN: RAV4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_11#uDGSmdCiP6rs2t9wwwedxTH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN: BATHROOM SINK")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_12#uDU8zIKANWK7VNnqWe8KLz7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE: BLOOD DOCTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_13#uDtioZM5dsW7Ritm6iEmZsA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN: TWO CARS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_14#ur8rpZX8m4A6xENFxEdrXLG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN:CANINE NOSES")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_15#uoyqZtqC2LG3kFybmTf5C3D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN: COVER UP")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_16#uB5sn2nGeawsHnM5jzJyQP8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN: NOTHING THERE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_17#uJMnRIPTNTcBrtG3rWHvOLC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN: EVIDENCE PILE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_18#ulIlN5xGN7y2v9fLuFf977F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN: HOSPITAL STOP")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_19#urxKDP6EQh7v9pv6Qnjw4d6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN: SECOND TRY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_20#uRQ23JkCl8c6Ji6S6JUXlp6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY: GARAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_21#uQesf54fELr2g3KfEhAVQGE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE: HEROES OR GOATS?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_22#uFAyJG46YcDgEpCqGmElEH5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO: THE CRIME")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_23#ufmLgza5bQasoKPAkATbkU3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE: KEN KRATZ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_24#u7mGOFlUqFDq8DhvlX95MuB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR: CREEPY KRATZ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_25#ucRl2QdgNze74DJpAdwvUgG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FIVE: COMPUTER DISK")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_26#u6nmGoaSnDbw9jJnyVLIr4G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SIX: FANTASY LIFE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_27#um3FhiGZav7SkXQJPMomn5D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-SEVEN: DAMAGED")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_28#uE4LjUbwtwb3nBjNuO3gaBG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-EIGHT: AVERY’S BRAIN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_29#uizhIN6HIHtkRBfV4UOf8c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-NINE: BOBBY’S GARAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/5YearsLater#uBjJ6trpyOpckgaZJpXiVID",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE YEARS LATER")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue#uWs98QQJCCmmVKjJX3DuCC9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: STEVEN AVERY TALKS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45546686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0